import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgDragDropModule } from 'ng-drag-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { RouterModule } from '@angular/router';
import { ShContextMenuModule } from 'ng2-right-click-menu';
import { MatExpansionModule } from '@angular/material';
import { OwlDateTimeModule } from 'ng-pick-datetime';
import { ActivityModule } from '../../../../../shared/modules/activity.module';
import { EditModule } from '../../../../../shared/modules/edit.module';
import { SharedModule } from '../../../../../shared/modules/shared.module';
import { SharedInputModule } from '../../../../../shared/modules/shared-input.module';
import { ProductFoldersModule } from '../../../../../features/product-folders/product-folders.module';
import { DateModule } from '../../../../../shared/components/forms/input/date/date.module';
import { CommonPaginationModule } from '../../../../../shared/components/listing/common/common-pagiation.module';
import { UserSkillsComponent } from './user-skills.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    EditModule,
    SharedModule.forRoot(),
    NgDragDropModule.forRoot(),
    DragDropModule,
    SharedInputModule,
    ProductFoldersModule,
    ShContextMenuModule,
    DateModule,
    MatExpansionModule,
    CommonPaginationModule,
    OwlDateTimeModule,
    ActivityModule,
  ],
  exports: [
    UserSkillsComponent,
  ],
  declarations: [
    UserSkillsComponent,
  ],
  entryComponents: [
    UserSkillsComponent,
  ],
})
export class UserSkillsModule { }
